import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Wellfleet Student Plan",
  shortName: "Wellfleet Student",
  slug: "wellfleet-student-plan-insurance",
  seoTitle: "Wellfleet Student Plan TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have a Wellfleet Student Plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Wellfleet student insurance in Coral Springs, FL.",
  seoKeywords:
    "Wellfleet Student Plan TMS coverage, Wellfleet TMS therapy, Wellfleet Student depression treatment Florida, Wellfleet mental health benefits Coral Springs FL, Wellfleet Student SAINT TMS",
  planType: "student health insurance plan",
  planRegion: "nationwide (colleges and universities)",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services for students",
  planSpecificIntro:
    "Wellfleet Student Plans are designed specifically for college and university students, providing health insurance coverage through participating institutions across the country. Wellfleet student plans typically include behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. Because student plans vary by institution and plan design, coverage for TMS, accelerated TMS protocols, and other advanced depression treatments depends on your specific school's plan, the underlying network, and documented prior treatment history.",
  officialResourceUrl: "https://www.wellfleetstudent.com/",
  officialResourceLabel: "Wellfleet Student official website",
};

export const WellfleetStudentPlanInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default WellfleetStudentPlanInsurance;
